import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Box, Typography, Tabs, Tab, TextField, Button, List, ListItem, ListItemText, IconButton, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';

const MemberDetailsForm = ({ open, onClose, memberId, projectId, refreshData }) => {
  const [currentTab, setCurrentTab] = useState(0);
  const [memberDetails, setMemberDetails] = useState({});
  const [roles, setRoles] = useState([]);
  const [teams, setTeams] = useState([]);
  const [memberTeams, setMemberTeams] = useState([]);
  const [memberTasks, setMemberTasks] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedTeam, setSelectedTeam] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false); // Delete modal state
  const [isAuthorized, setIsAuthorized] = useState(false);
  const { t } = useTranslation();
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  const [tabValue, setTabValue] = useState(currentTab);

  const handleTabSwitch = (event, newValue) => {
    setTabValue(newValue);
    handleTabChange(event, newValue);
  };


  
  


  useEffect(() => {
    if (memberId) {
      fetchMemberDetails();
      fetchRoles();
      fetchTeams();
      fetchMemberTasks();
      fetchUserRole()
    }
  }, [memberId]);

  // Üyenin detaylarını çekme
  const fetchMemberDetails = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/projects/${projectId}/members/${memberId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMemberDetails(response.data);
      setSelectedRole(response.data.roleId || ''); // Mevcut rolü seç
      // Üyenin takımlarını state'e ata
    setMemberTeams(response.data.teams || []);
    } catch (error) {
      
    }
  };

  // Rolleri çekme
  const fetchRoles = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get('/api/roles', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRoles(response.data);
    } catch (error) {
      
    }
  };

  // Projedeki takımları çekme
  const fetchTeams = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/teams/${projectId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTeams(response.data);
    } catch (error) {
      
    }
  };

 

  // Üyenin rolünü güncelleme
  const handleAssignRole = async () => {
    try {
      const token = localStorage.getItem('token');
      await api.patch(`/api/projects/${projectId}/members/${memberId}/role`, { roleId: selectedRole }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert(t("userRoleUpdated"));
      fetchMemberDetails();
    } catch (error) {
      
    }
  };

  // Üyeyi takıma ekleme
  const handleAssignTeam = async () => {
    try {
      const token = localStorage.getItem('token');
      await api.post(`/api/projects/${projectId}/teams/${selectedTeam.id}/members`, { userId: memberId }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert(t("userAddedToTeam"));
      fetchMemberDetails(); // Üyenin takımlarını güncelle
    } catch (error) {
      
    }
  };

  // Üyenin bir takımdan çıkarılması
  const handleRemoveFromTeam = async (teamId) => {
    try {
      const token = localStorage.getItem('token');
      await api.delete(`/api/teams/${selectedTeam.id}/members/${memberId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert(t("userRemovedFromTeam"));
      fetchMemberDetails(); // Üyenin takımlarını güncelle
      setShowDeleteModal(false);
    } catch (error) {
      
    }
  };

  // Üyenin görevlerini getirme fonksiyonu
  const fetchMemberTasks = async () => {
    try {
        const token = localStorage.getItem('token');
      const response = await api.get(`/api/projects/${projectId}/members/${memberId}/tasks`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMemberTasks(response.data);
    } catch (error) {
      
    }
  };

  const openDeleteModal = (team) => {
    setSelectedTeam(team);
    setShowDeleteModal(true); // Silme modalını aç
  };

  // Tab değişim fonksiyonu
  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const fetchUserRole = async () => {
    try {
      const token = localStorage.getItem('token');
        // API isteğini yap
        const roleResponse = await api.get(`/api/projects/${projectId}/role`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        console.log("rol " + roleResponse.data.roleId);
        if (roleResponse.data.roleId === 1)
        {
            setIsAuthorized(true);
        }
        else
        {
            setIsAuthorized(false);
        }
    } catch (error) {
        
    }
};

  return (
    <Modal open={open} onClose={onClose}>
  <Box
    sx={{
      padding: 3,
      backgroundColor: 'white',
      width: { xs: '95vw', sm: '80vw', md: '70vw' },
      height: '85vh',
      margin: '5% auto',
      borderRadius: 2,
      boxShadow: 5,
      overflowY: 'auto',
    }}
  >
    <Typography variant="h5" color="primary" mb={2}>
      {t("memberDetails")}: {memberDetails.name}
    </Typography>

    <Tabs value={tabValue} onChange={handleTabSwitch} centered sx={{ mb: 3 }}>
      <Tab label={t("memberDetailsTab")} value={0} />
      <Tab label={t("memberRoleTab")} value={1} />
      <Tab label={t("memberTeamsTab")} value={2} />
      <Tab label={t("memberTasksTab")} value={3} />
    </Tabs>

    {/* Member Details Tab */}
    {tabValue === 0 && (
      <Box mb={2}>
        <Typography variant="subtitle1" gutterBottom>
          <strong>{t("name")}:</strong> {memberDetails.name}
        </Typography>
        <Typography variant="subtitle1">
          <strong>{t("email")}:</strong> {memberDetails.email}
        </Typography>
      </Box>
    )}

    {/* Member Role Tab */}
    {tabValue === 1 && (
      <Box>
        <Typography variant="h6" gutterBottom>
          {t("assignedRole")}
        </Typography>
        <Typography color="textSecondary" mb={2}>
          {roles.find((role) => role.id === selectedRole)?.name || t("noRoleAssigned")}
        </Typography>
        {isAuthorized && (
          <>
            <FormControl fullWidth variant="outlined" sx={{ mb: 2 }}>
              <InputLabel>{t("selectRole")}</InputLabel>
              <Select value={selectedRole} onChange={(e) => setSelectedRole(e.target.value)} label={t("selectRole")}>
                {roles.map((role) => (
                  <MenuItem key={role.id} value={role.id}>
                    {role.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button variant="contained" color="primary" onClick={handleAssignRole} fullWidth>
              {t("updateRole")}
            </Button>
          </>
        )}
      </Box>
    )}

    {/* Member Teams Tab */}
    {tabValue === 2 && (
      <Box>
        <Typography variant="h6" gutterBottom>
          {t("memberTeams")}
        </Typography>
        <List sx={{ maxHeight: 250, overflowY: 'auto', mb: 2 }}>
          {memberTeams.map((team) => (
            <ListItem key={team.id} secondaryAction={isAuthorized && (
                <IconButton edge="end" onClick={() => openDeleteModal(team)}>
                  <DeleteIcon color="error" />
                </IconButton>
              )}>
              <ListItemText primary={team.name} />
            </ListItem>
          ))}
        </List>

        {isAuthorized && (
          <>
            <FormControl fullWidth variant="outlined" sx={{ mb: 2 }}>
              <InputLabel>{t("assignToTeam")}</InputLabel>
              <Select
                value={selectedTeam?.id || ''}
                label={t("assignToTeam")}
                onChange={(e) => {
                  const selected = teams.find((team) => team.id === e.target.value);
                  setSelectedTeam(selected);
                }}
              >
                {teams.map((team) => (
                  <MenuItem key={team.id} value={team.id}>
                    {team.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button variant="contained" color="primary" onClick={handleAssignTeam} fullWidth disabled={!selectedTeam}>
              {t("addToTeam")}
            </Button>
          </>
        )}
      </Box>
    )}

    {/* Member Tasks Tab */}
    {tabValue === 3 && (
      <Box>
        <Typography variant="h6" gutterBottom>
          {t("assignedTasks")}
        </Typography>
        <List sx={{ maxHeight: 250, overflowY: 'auto', mb: 2 }}>
          {memberTasks.length > 0 ? (
            memberTasks.map((task) => (
              <ListItem key={task.id}>
                <ListItemText
                  primary={task.title}
                  secondary={`${t("dueDate")}: ${task.due_date} | ${t("status")}: ${task.status}`}
                />
              </ListItem>
            ))
          ) : (
            <Typography color="textSecondary">{t("noTasksAssigned")}</Typography>
          )}
        </List>
      </Box>
    )}

    {/* Delete Team Modal */}
    <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
      <Box
        sx={{
          backgroundColor: 'white',
          padding: 3,
          margin: '15% auto',
          width: { xs: '90vw', sm: '400px' },
          borderRadius: 2,
          boxShadow: 5,
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" gutterBottom>
          {t("confirmDeletion")}
        </Typography>
        <Typography variant="body1" mb={2}>
          {t("confirmRemoveUser", { teamName: selectedTeam?.name })}
        </Typography>
        <Button onClick={handleRemoveFromTeam} variant="contained" color="error" fullWidth sx={{ mb: 2 }}>
          {t("delete")}
        </Button>
        <Button onClick={() => setShowDeleteModal(false)} variant="outlined" color="primary" fullWidth>
          {t("cancel")}
        </Button>
      </Box>
    </Modal>
  </Box>
</Modal>

  );
};

export default MemberDetailsForm;
